import {withSystem, EnvTypes, Type} from '@packages/systems/wfdl';
import {TOption} from '@packages/systems/plugins/Option';
import {type DynamoEnvValueType} from './types';
import {TPredicate, FALSE, TRUE} from '@packages/systems/plugins-utils/Boolean';
import {operand} from '@packages/systems/plugins/ConditionsOperand';

export const createIsSetValues = (dynamoTypeName: string, type: Type) => {
  return {
    [`dynamo${dynamoTypeName}IsSet`]: isSetCreator(type),
    [`dynamo${dynamoTypeName}IsNotSet`]: isNotSetCreator(type),
    [`dynamo${dynamoTypeName}Operand`]: operand(TOption(type)),
  };
};

const isSetCreator = (type: Type): EnvTypes.TypedValue => {
  return {
    envType: {
      dataType: withSystem({label: 'is set'}, TPredicate(TOption(type))),
      exported: 'visible',
    },
    value: (x: DynamoEnvValueType<unknown>) => {
      if (x === null || x.tag === 'None') {
        return FALSE;
      }

      return TRUE;
    },
  };
};

const isNotSetCreator = (type: Type): EnvTypes.TypedValue => {
  return {
    envType: {
      dataType: withSystem({label: 'is not set'}, TPredicate(TOption(type))),
      exported: 'visible',
    },
    value: (x: DynamoEnvValueType<unknown>) => {
      if (x === null || x.tag === 'None') {
        return TRUE;
      }

      return FALSE;
    },
  };
};
